module.exports = __webpack_public_path__ + "img/12.24f59893.svg";